import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

declare function require(url: string);

const conf = require('assets/appconf.json');

@Injectable()
export class WsTerceiros {

  private spaUrl = conf.server.url;
  private headers = new HttpHeaders();

  constructor(private http: HttpClient) {
    this.headers = this.headers.append('Authorization', 'Basic ' + btoa('spa-painel:c2pyW2FnCrQ2'));
    this.headers = this.headers.append('Content-Type', 'application/x-www-form-urlencoded');
  }

  public getCNPJReceita(cnpj) {
    const param = cnpj.replace(/[^\w\s]/gi, '');
    return this.http.get(`${this.spaUrl}/get/receita/${param}`, {headers: this.headers});
  }

  public getCepConsulta(cep) {
    const param = cep.replace(/[^\w\s]/gi, '');
    return this.http.get(`${this.spaUrl}/get/cep/${param}`, {headers: this.headers});
  }

  public getIp() {
    const url = 'http://ipinfo.io';
    return this.http.get(url);
  }

}

